import {useState, useEffect} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import {setTabOnFocus, toggleRightDrawer, handleSnackBar} from '../../store/global/actions';
import {marginBottomForBreadCrumb} from '../../config/styles';
import {useDispatch, useSelector} from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import {Grid} from '@material-ui/core';
import ContextGenerator from '../molecules/simulations/ContextGenerator';
import ProfileSelector from '../molecules/simulations/ProfileSelector';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ListSimulationProfiles from '../molecules/simulations/ListSimulationProfiles';
import DeleteSimulationProfileAlert from '../molecules/alerts/DeleteSimulationProfileAlert';
import CreateTestsuite from '../molecules/simulations/CreateTestsuite';
import EditTestsuite from '../molecules/simulations/EditTestsuite';
import { getLogRedirectionData, getTabOnFocus } from '../../store/global/selectors';
import ProbabilityTable from '../molecules/simulations/ProbabilityTable';
import CompactAlert from '../molecules/logs/LogRedirectionAlert';

export default function TestsuiteTabs({element}) {
  // console.log("TestsuiteTabs---------------------------->", {element})
  const dispatch = useDispatch();
  const tabOnFocus = useSelector(getTabOnFocus);
  const [tabActive, setTabActive] = useState("");
  const [openTab, setOpenTab] = useState(0);
  const [elementId, setElementId] = useState(null);
  const logRedirectionData = useSelector(getLogRedirectionData);


  const detailsBC = [
    {label: 'Testsuite', url: null},
    {label: element.name, url: null},
  ];
  const [action, setAction] = useState(0);

  // to close the 'add profile' page, if the tab is changed from Profile
  // if((action.action == "add_profile" || action.action ==  "edit_profile") && openTab != 4){
  //   setAction({});
  // }

  useEffect(() => {
    setElementId(element ? element.id : null);
    setOpenTab(tabOnFocus);
  }, [tabOnFocus, element])

  const onCancel = () => {
    setAction({});
    dispatch(toggleRightDrawer());
  };

  const onCompletion = (action, type, message) => {
    switch (action) {
      case 'add':
        dispatch(handleSnackBar({open: true, message: message ? message : 'Testsuite created successfully.', severity: 'success'}));
        break;
      case 'delete':
        dispatch(handleSnackBar({open: true, message: message ? message : 'Testsuite deleted successfully.', severity: 'success'}));
        break;
      case 'edit':
        dispatch(handleSnackBar({open: true, message: message ? message : 'Testsuite updated successfully.', severity: 'success'}));
        break;
    }
    setAction({});
  };

  const decideTabActive = (value) => {
    if (value == 0) {
      element.action = "edit"
    }else if(value == 1){
      element.action = "configure_context"
    }else if(value == 2){
      element.action = "configure_profile"
    }
  };

  
  const onClose = () => {
    setAction({});
  };

  // useEffect(() => {
  //   dispatch(triggerTour({currentTour: "testsuiteRightDrawer"}))
  // },[])
  console.log({logRedirectionData, element})
  return (
    <>
      <AppBar position="static">
        <Tabs
          value={openTab}
          onChange={(e, v) => {
            dispatch(setTabOnFocus(v));
            setOpenTab(v);
            decideTabActive(v);
          }}
          aria-label="TestsuiteTabs">

          <Tab label="Testsuite" data-ui-tour-id="testsuite-tab" />
          <Tab label="Context" data-ui-tour-id="context-tab" disabled={element.action === "create" ? true : false} />
          <Tab label="Profile" data-ui-tour-id="profile-tab" disabled={element.action === "create" ? true : false} />
          <Tab label="Probability" data-ui-tour-id="probability-tab" disabled={element.action === "create" ? true : false} /> 
        </Tabs>
      </AppBar>

      <TabPanel value={openTab} index={0}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={detailsBC} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        {element.action === 'create' && <CreateTestsuite  onClose={onCancel} />}
        {element.action === 'edit' && <EditTestsuite id={element.id} onCompletion={onCompletion} onClose={onCancel} />}
      </TabPanel>



      <TabPanel value={openTab} index={1}>

        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={[...detailsBC, {label: 'Context', url: null}]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />
        {
          (logRedirectionData?.entity === "testsuite" && logRedirectionData.entityId === element.id) && logRedirectionData.tabOnfocus === 1 ?
            <CompactAlert severity={logRedirectionData?.level} >{logRedirectionData?.message}</CompactAlert>
          :
          null

        }
        <ContextGenerator entityId={element != undefined ? element.id : ""} type="testsuite" onCancel={onCancel} />
      </TabPanel>



      <TabPanel value={openTab} index={2}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={[...detailsBC, {label: 'Profile', url: null}]} />
          </Grid>

          {Object.keys(action).length === 0 && (
            <Grid item xs={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Tooltip title="Create button">
                <span>
                  <Button id="add-profile" onClick={(e) => setAction({action: 'add_profile'})} color="primary" variant="contained" style={{marginLeft: 10, marginBottom: 10}}>
                    Add Profile
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        {Object.keys(action).length === 0 && <ListSimulationProfiles entityId={element != undefined ? element.id : ""} type="testsuite" setAction={setAction} />}
        {action.action == 'add_profile' && <ProfileSelector onClose={onCancel} onCompletion={onCompletion} entityId={element != undefined ? element.id : ""} type='testsuite' />}
        {action.action == 'edit_profile' && <ProfileSelector onClose={onCancel} onCompletion={onCompletion} action={action} entityId={element != undefined ? element.id : ""} type='testsuite' />}
        {action.action == 'delete_profile' && <DeleteSimulationProfileAlert title='Delete Testsuite Profile' testsuiteId={element?.id} entityId={element != undefined ? element.id : ""} type='testsuite' onClose={onClose} onCompletion={onCompletion} element={action.item} itemName={action?.name} />}
      </TabPanel>

      <TabPanel value={openTab} index={3}>
        <Grid container direction={'row'} spacing={2}>
            <Grid item xs={8}>
              <BreadCrumb items={[...detailsBC, {label: 'Probability', url: null}]} />
            </Grid>
        </Grid>
        
        <Divider style={marginBottomForBreadCrumb} />
        
        <ProbabilityTable onClose={onCancel} id={element?.id}/>
      </TabPanel>
    </>
  );
}
